import { makeStyles } from '@material-ui/core/styles';

export const useStylesAlertModal = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        border: 'none !important',
        padding: '50px',
        width: '500px',
        position: 'relative',
        borderRadius: '10px',
        [theme.breakpoints.down('sm')]: {
            padding: ' 20px !important',
            height: 'auto !important',
            width: '92% !important',
        },
        "&:focus": {
            outline: 'none',
        }
    },
}));
